// LABEL_FLOW_DESCRIPTION

import { DC_Domain_Models_Products_DiscountType } from '@monorepo-types/dc';

// Contract Start Date Values

export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_URGENT = 0;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX_URGENT = 14;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_SWITCH = 17;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_MOVING_OUT = 15;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX = 143;

export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_URGENT = 0;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX_URGENT = 3;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_SWITCH = 17;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_MOVING_OUT = 4;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX = 143;

export const CONTRACT_CONSIDERATION_PERIOD_IN_DAYS = 14;

// Max Usage Values
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 5000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_WARMTH = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_WATER = 10000;

export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 10000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 10000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 5000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_WARMTH = 0;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_WATER = 0;

// Misc
export const SOLAR_PANEL_OUTPUT = 240;
export const ENECO_ENERGY_FLOW_GIFT = 'gift';

export const NEW_ENERGY_3_YEARS_DISCOUNT_TYPE = 'newEnergy3Years' as DC_Domain_Models_Products_DiscountType;
export const EXTEND_CONTRACT_DISCOUNT_TYPE = 'extend3Years' as DC_Domain_Models_Products_DiscountType;

export const DURATION_3_YEARS = 3;
export const BY_PERIOD_YEAR = 'Y';
